export const BULAN = [
  "", "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export function rp(v) {
  const n = Math.round(Number(v) || 0);
  return (n < 0 ? "-" : "") + Math.abs(n).toLocaleString("en-US");
}

export function fmtDate(s) {
  if (!s) return "\u2014";
  const [y, m, d] = String(s).slice(0, 10).split("-");
  if (!y || !m) return String(s);
  return `${(d || "01").padStart(2, "0")}/${m.padStart(2, "0")}/${y.slice(-2)}`;
}

export function rpFull(v) {
  return "Rp " + rp(v);
}

export function autoBonus(hari, eligible) {
  if (!eligible) return 0;
  const h = Number(hari) || 0;
  if (h > 17) return 200000;
  if (h >= 14) return 100000;
  return 0;
}

export const BPJS_AMOUNT = 45000;

const normItems = (list) =>
  (list || []).map((p) => ({
    keterangan: p.keterangan || "",
    nominal: Number(p.nominal) || 0,
  }));

export function computeEntry(e) {
  const pendapatan_items0 = normItems(e.pendapatan_items);
  const potongan_items0 = normItems(e.potongan_items);
  const pendapatan_lain0 = pendapatan_items0.reduce((a, p) => a + p.nominal, 0);
  const potongan_lain0 = potongan_items0.reduce((a, p) => a + p.nominal, 0);
  if (e.is_jarit) {
    // borongan / piece-rate tailors: values are driven by the Tukang Jarit ledger
    const upah = Math.round(Number(e.jarit_total) || 0);
    const bonus = Math.round(Number(e.jarit_bonus) || 0);
    const bpjs_potongan = Math.round(Number(e.jarit_bpjs) || 0);
    const kasbon = Number(e.kasbon) || 0;
    const total_pendapatan = upah + bonus + pendapatan_lain0;
    const total_potongan = bpjs_potongan + kasbon + potongan_lain0;
    return {
      ...e,
      pendapatan_items: pendapatan_items0,
      potongan_items: potongan_items0,
      upah,
      bonus,
      kasbon,
      pendapatan_lain_total: pendapatan_lain0,
      potongan_lain_total: potongan_lain0,
      bpjs_potongan,
      total_pendapatan,
      total_potongan,
      total: total_pendapatan - total_potongan,
    };
  }
  const hari = Number(e.hari_kerja) || 0;
  const upah = Math.round((Number(e.rate_harian) || 0) * hari);
  const bonus =
    e.bonus_manual === null || e.bonus_manual === undefined || e.bonus_manual === ""
      ? autoBonus(hari, e.eligible_bonus)
      : Number(e.bonus_manual) || 0;
  const kasbon = Number(e.kasbon) || 0;
  const pendapatan_items = normItems(e.pendapatan_items);
  const potongan_items = normItems(e.potongan_items);
  const pendapatan_lain_total = pendapatan_items.reduce((a, p) => a + p.nominal, 0);
  const potongan_lain_total = potongan_items.reduce((a, p) => a + p.nominal, 0);
  const bpjs_potongan = e.bpjs && hari > 0 ? BPJS_AMOUNT : 0;
  const total_pendapatan = upah + bonus + pendapatan_lain_total;
  const total_potongan = bpjs_potongan + kasbon + potongan_lain_total;
  return {
    ...e,
    pendapatan_items,
    potongan_items,
    upah,
    bonus,
    kasbon,
    pendapatan_lain_total,
    potongan_lain_total,
    bpjs_potongan,
    total_pendapatan,
    total_potongan,
    total: total_pendapatan - total_potongan,
  };
}

export function summarize(rows) {
  const transfer = rows.filter((r) => r.metode === "transfer" && !r.is_jarit);
  const tunai = rows.filter((r) => r.metode !== "transfer" && !r.is_jarit);
  const jarit = rows.filter((r) => r.is_jarit);
  const st = transfer.reduce((a, r) => a + r.total, 0);
  const su = tunai.reduce((a, r) => a + r.total, 0);
  const sj = jarit.reduce((a, r) => a + r.total, 0);
  const sum = (f) => rows.reduce((a, r) => a + f(r), 0);
  return {
    subtotal_transfer: st,
    subtotal_tunai: su,
    subtotal_jarit: sj,
    total_keseluruhan: st + su + sj,
    count_transfer: transfer.length,
    count_tunai: tunai.length,
    count_jarit: jarit.length,
    count_total: rows.length,
    total_hari: sum((r) => Number(r.hari_kerja) || 0),
    total_upah: sum((r) => r.upah),
    total_bonus: sum((r) => r.bonus),
    total_pendapatan_lain: sum((r) => r.pendapatan_lain_total),
    total_bpjs: sum((r) => r.bpjs_potongan),
    total_kasbon: sum((r) => r.kasbon),
    total_potongan_lain: sum((r) => r.potongan_lain_total),
    total_potongan: sum((r) => r.total_potongan),
  };
}

export function slipMessage(row, periodeLabel) {
  const lines = [
    `*Slip Gaji ${periodeLabel}*`,
    `${row.nama}`,
    ``,
    `Hari kerja: ${row.hari_kerja || 0}`,
    `Upah: Rp ${rp(row.upah)}`,
    `Bonus: Rp ${rp(row.bonus)}`,
  ];
  row.pendapatan_items?.filter((p) => p.nominal).forEach((p) =>
    lines.push(`${p.keterangan || "Pendapatan lainnya"}: Rp ${rp(p.nominal)}`)
  );
  if (row.bpjs_potongan) lines.push(`BPJS: -Rp ${rp(row.bpjs_potongan)}`);
  if (row.kasbon) lines.push(`Kasbon: -Rp ${rp(row.kasbon)}`);
  row.potongan_items?.filter((p) => p.nominal).forEach((p) =>
    lines.push(`${p.keterangan || "Potongan"}: -Rp ${rp(p.nominal)}`)
  );
  lines.push(``, `*Diterima: Rp ${rp(row.total)}*`, ``, `Meranggi Garment`);
  return lines.join("\n");
}
